import React, { useEffect, useState } from 'react';
import { sendLessonData } from '../../api/fetchLessons'; // Импортируем функцию для общения с сервером
import Neirotopics from '../../components/Neirotopics/Neirotopics';
import { useDelayedLoading } from '../../hooks/useDelayedLoading';
import Loading from '../../components/Loading/Loading';
import { useAppConfig } from '../../context/AppConfigContext';

function LessonList({ onLessonSelect, userId }) {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useAppConfig();
  const showLoading = useDelayedLoading(loading, 3000);

  useEffect(() => {
    sendLessonData({ userId })
      .then(setTopics)
      .catch(setError)
      .finally(() => setLoading(false));
  }, []);

  if (showLoading) return <Loading />;
  if (error) return <div>Error: {error}</div>;

  return (
      <Neirotopics data={topics} onSelect={onLessonSelect} neirotitle={t.lessons.menu} source="lesson"/>
  );
}
export default LessonList;